import bgc from "@/assets/images/community/banner-compress.png";
import styles from './index.module.scss'
import { Col, Row, Divider } from 'antd';
// import { useEffect, useState } from 'react';
// import { competitionList } from "@/apis/community";
import nostart from "@/assets/images/community/nostart.png";
import ing from "@/assets/images/community/ing.png";
import judge from "@/assets/images/community/judge.png";
import { FieldTimeOutlined, EyeOutlined } from '@ant-design/icons';
import classNames from "classnames";
import intl from "react-intl-universal";
import { useMemo } from "react";
import img1 from "@/assets/images/community/img1.png";
import img2 from "@/assets/images/community/img2.jpeg";
import img3 from "@/assets/images/community/img3.png";
import img1_cn from "@/assets/images/community/img1_cn.png";
import img2_cn from "@/assets/images/community/img2_cn.jpg";
import img3_cn from "@/assets/images/community/img3_cn.png";

const statusObj = {
	0: {
		title: "Not Started",
		img: nostart,
	},
	1: {
		title: "In Progress",
		img: ing,
	},
	2: {
		title: "Under Review",
		img: judge,
	},
	3: {
		title: "Completed",
		img: nostart,
	},
};
const MatchCenter = () => {

	const lang = useMemo(() => {
		return localStorage.getItem("lang") || "en-US"
	}, []);

	const list = [
		{
			"id": 1,
			"name": "【Digital Intelligence & Space Information】OGE Application Innovation Development Competition",
			"status": 3,
			"beginDate": "2024-04-15",
			"endDate": "2026-09-10",
			"pageView": 7,
			"visible": 0,
			"route": "/competition",
			"image": lang === "zh-CN" ? img1_cn : img1,
			"createTime": "2024-04-10 11:50:06",
			"updateTime": "2025-01-10 15:44:00",
			"remainDays": null
		},
		{
			"id": 2,
			"name": "Digital Intelligence Education Innovation Competition - Aerospace Information Track",
			"status": 3,
			"beginDate": "2024-06-27",
			"endDate": "2024-08-31",
			"pageView": 1,
			"visible": 0,
			"route": "/innovation-competition",
			"image": lang === "zh-CN" ? img2_cn :img2,
			"createTime": null,
			"updateTime": "2025-01-10 15:44:00",
			"remainDays": null
		},
		{
			"id": 3,
			"name": "Remote Sensing Image Intelligent Processing Algorithm Competition",
			"status": 3,
			"beginDate": "2024-08-08",
			"endDate": "2024-09-05",
			"pageView": null,
			"visible": 0,
			"route": "/competition3",
			"image": lang === "zh-CN" ? img3_cn :img3,
			"createTime": "2024-08-14 22:49:14",
			"updateTime": "2025-01-10 15:44:00",
			"remainDays": null
		}
	]
	// const [list, setList] = useState([])
	const goToDetail = (link) => {
		window.open("http://openearth.org.cn" + link, '_blank');
	};

	const backgroundstyle = (path) => {
		return {
			backgroundImage: `url(${path})`,
			// backgroundstyle: "cover",
			// backgroundRepeat: "no-repeat",
			// backgroundPosition: "100% 100%"
		}
	}
	// const getList = async () => {
	// 	competitionList().then(res => {
	// 		setList(res.data || [])
	// 	}).then(err => { })
	// }
	// useEffect(() => {
	// 	getList()
	// }, [])

	return (
		<div className={styles.matchBox}>
			<img src={bgc} />
			<div className={'container '}>
				<Row gutter={40} align="stretch" className={styles.rowwBox}>
					{list.map((item, index) => {
						return <Col span={12} key={index + "_match"}>
							<div className={styles.tabBox} onClick={() => goToDetail(item.route)}>
								<img src={item.image} />
								<div>
									<div>
										<div>{intl.get(`community.${item.name}`)}</div>
										<i style={backgroundstyle(statusObj[item.status].img)}>{intl.get(`community.${statusObj[item.status].title}`)}</i>
									</div>
									<span>{intl.get("community.Registration deadline")}：{item.endDate}</span>
									<Divider />
									<p className={classNames('flex_box', 'flex_between', styles.pBox)}>
										<span><FieldTimeOutlined />{item.visible} {intl.get("community.days")}</span>
										<span><EyeOutlined />{item.pageView ? item.pageView + 630 : 344}</span>
									</p>
								</div>

							</div>
						</Col>
					})}
				</Row>
			</div>
		</div>
	)
}
export default MatchCenter;